// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"Formulario_containerPrincipal__FUIwN","divFormulario":"Formulario_divFormulario__-fRZ9"};